import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { UserService } from './user.service';

const BASE_URL = environment.base_url_second;


@Injectable({
    providedIn: 'root'
})
export class ProductsService {

    constructor(private http: HttpClient) { }

    uploadImage(name: string, formJson: any) {
        const url = `${BASE_URL}/image/upload?file=${name}&destination=productImages`;
        return this.http.post(url, formJson);
    }

    addProduct(formJson: any) {
        const url = `${BASE_URL}/product`;
        return this.http.post(url, formJson);
    }

    getAllProduct() {
        const url = `${BASE_URL}/products`;
        return this.http.get(url);
    }

    getPriceFromProduct(id: string, stripeAccount: string | number) {
        const url = `${BASE_URL}/product/${id}/prices/${stripeAccount}`;
        return this.http.get(url);
    }

    getProductById(id: string, stripeAccount: string | number) {
        const url = `${BASE_URL}/product/${id}/${stripeAccount}`;
        return this.http.get(url);
    }

    uploadFile(name: string, formJson: any) {
        const url = `${BASE_URL}/image/upload?file=${name}&destination=customForms`;

        return this.http.post(url, formJson).pipe(
            catchError((error) => {
                console.error('Error uploading file:', error);
                return throwError('Something went wrong with the upload.');
            })
        );
    }

    updateProduct(productId: string, product: any) {
        const url = `${BASE_URL}/product/${productId}`;
        return this.http.put(url, product);
    }
}
